/**
 * AssignmentCount — the shared shape for the admin list count columns
 * (contractor Jobs, verifier Verifications, client Projects).
 *
 * Renders a total with an "N active" hint and a tooltip breaking the number
 * down. Feed it a stats object from AdminDashboardService's
 * _accumulateAssignments — { total, active, completed, cancelled, bySource } —
 * and a map of bySource key to how that source should read.
 */

import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { status as statusTokens, text } from '../../theme/colors';

export const EMPTY_VALUE = '—';

const AssignmentCount = ({ stats, sourceLabels = {} }) => {
  if (!stats || (stats.total === 0 && stats.cancelled === 0)) return <>{EMPTY_VALUE}</>;

  const breakdown = [
    `${stats.active} active, ${stats.completed} completed`,
    ...Object.entries(sourceLabels)
      .filter(([key]) => stats.bySource?.[key])
      .map(([key, label]) => `${stats.bySource[key]} ${label}`),
    stats.cancelled ? `${stats.cancelled} cancelled (not counted)` : null,
  ].filter(Boolean);

  return (
    <Tooltip title={breakdown.join(' · ')} arrow>
      <Box sx={{ display: 'inline-flex', alignItems: 'baseline', gap: 0.75, cursor: 'default' }}>
        <Typography sx={{ fontSize: 15, fontWeight: 700, color: text.primary, lineHeight: 1 }}>
          {stats.total}
        </Typography>
        {stats.active > 0 && (
          <Typography variant="caption" sx={{ color: statusTokens.warningDark, fontWeight: 600 }}>
            {stats.active} active
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default AssignmentCount;
